// NEC 2023 Tables 430.248 and 430.250
// Full-Load Currents for Motors

// Table 430.248 - Single-Phase AC Motors
// Full-Load Currents in Amperes
interface SinglePhaseMotorFLA {
  hp: number;
  fla115V: number;
  fla200V: number;
  fla208V: number;
  fla230V: number;
}

const TABLE_430_248: SinglePhaseMotorFLA[] = [
  { hp: 0.167, fla115V: 4.4, fla200V: 2.5, fla208V: 2.4, fla230V: 2.2 },    // 1/6
  { hp: 0.25, fla115V: 5.8, fla200V: 3.3, fla208V: 3.2, fla230V: 2.9 },     // 1/4
  { hp: 0.333, fla115V: 7.2, fla200V: 4.1, fla208V: 4.0, fla230V: 3.6 },    // 1/3
  { hp: 0.5, fla115V: 9.8, fla200V: 5.6, fla208V: 5.4, fla230V: 4.9 },
  { hp: 0.75, fla115V: 13.8, fla200V: 7.9, fla208V: 7.6, fla230V: 6.9 },
  { hp: 1, fla115V: 16, fla200V: 9.2, fla208V: 8.8, fla230V: 8 },
  { hp: 1.5, fla115V: 20, fla200V: 11.5, fla208V: 11, fla230V: 10 },
  { hp: 2, fla115V: 24, fla200V: 13.8, fla208V: 13.2, fla230V: 12 },
  { hp: 3, fla115V: 34, fla200V: 19.6, fla208V: 18.7, fla230V: 17 },
  { hp: 5, fla115V: 56, fla200V: 32.2, fla208V: 30.8, fla230V: 28 },
  { hp: 7.5, fla115V: 80, fla200V: 46, fla208V: 44, fla230V: 40 },
  { hp: 10, fla115V: 100, fla200V: 57.5, fla208V: 55, fla230V: 50 },
];

// Table 430.250 - Three-Phase AC Motors
// Full-Load Currents in Amperes
interface ThreePhaseMotorFLA {
  hp: number;
  fla115V: number;
  fla200V: number;
  fla208V: number;
  fla230V: number;
  fla460V: number;
  fla575V: number;
  fla2300V: number;
}

const TABLE_430_250: ThreePhaseMotorFLA[] = [
  { hp: 0.5, fla115V: 4.4, fla200V: 2.5, fla208V: 2.4, fla230V: 2.2, fla460V: 1.1, fla575V: 0.9, fla2300V: 0 },
  { hp: 0.75, fla115V: 6.4, fla200V: 3.7, fla208V: 3.5, fla230V: 3.2, fla460V: 1.6, fla575V: 1.3, fla2300V: 0 },
  { hp: 1, fla115V: 8.4, fla200V: 4.8, fla208V: 4.6, fla230V: 4.2, fla460V: 2.1, fla575V: 1.7, fla2300V: 0 },
  { hp: 1.5, fla115V: 12, fla200V: 6.9, fla208V: 6.6, fla230V: 6, fla460V: 3, fla575V: 2.4, fla2300V: 0 },
  { hp: 2, fla115V: 13.6, fla200V: 7.8, fla208V: 7.5, fla230V: 6.8, fla460V: 3.4, fla575V: 2.7, fla2300V: 0 },
  { hp: 3, fla115V: 0, fla200V: 11, fla208V: 10.6, fla230V: 9.6, fla460V: 4.8, fla575V: 3.9, fla2300V: 0 },
  { hp: 5, fla115V: 0, fla200V: 17.5, fla208V: 16.7, fla230V: 15.2, fla460V: 7.6, fla575V: 6.1, fla2300V: 0 },
  { hp: 7.5, fla115V: 0, fla200V: 25.3, fla208V: 24.2, fla230V: 22, fla460V: 11, fla575V: 9, fla2300V: 0 },
  { hp: 10, fla115V: 0, fla200V: 32.2, fla208V: 30.8, fla230V: 28, fla460V: 14, fla575V: 11, fla2300V: 0 },
  { hp: 15, fla115V: 0, fla200V: 48.3, fla208V: 46.2, fla230V: 42, fla460V: 21, fla575V: 17, fla2300V: 0 },
  { hp: 20, fla115V: 0, fla200V: 62.1, fla208V: 59.4, fla230V: 54, fla460V: 27, fla575V: 22, fla2300V: 0 },
  { hp: 25, fla115V: 0, fla200V: 78.2, fla208V: 74.8, fla230V: 68, fla460V: 34, fla575V: 27, fla2300V: 0 },
  { hp: 30, fla115V: 0, fla200V: 92, fla208V: 88, fla230V: 80, fla460V: 40, fla575V: 32, fla2300V: 0 },
  { hp: 40, fla115V: 0, fla200V: 120, fla208V: 114, fla230V: 104, fla460V: 52, fla575V: 41, fla2300V: 0 },
  { hp: 50, fla115V: 0, fla200V: 150, fla208V: 143, fla230V: 130, fla460V: 65, fla575V: 52, fla2300V: 0 },
  { hp: 60, fla115V: 0, fla200V: 177, fla208V: 169, fla230V: 154, fla460V: 77, fla575V: 62, fla2300V: 16 },
  { hp: 75, fla115V: 0, fla200V: 221, fla208V: 211, fla230V: 192, fla460V: 96, fla575V: 77, fla2300V: 20 },
  { hp: 100, fla115V: 0, fla200V: 285, fla208V: 273, fla230V: 248, fla460V: 124, fla575V: 99, fla2300V: 26 },
  { hp: 125, fla115V: 0, fla200V: 359, fla208V: 343, fla230V: 312, fla460V: 156, fla575V: 125, fla2300V: 31 },
  { hp: 150, fla115V: 0, fla200V: 414, fla208V: 396, fla230V: 360, fla460V: 180, fla575V: 144, fla2300V: 37 },
  { hp: 200, fla115V: 0, fla200V: 552, fla208V: 528, fla230V: 480, fla460V: 240, fla575V: 192, fla2300V: 49 },
  // NEC Table 430.250 shows "—" (not available) for 230V at 250-500 HP
  { hp: 250, fla115V: 0, fla200V: 0, fla208V: 0, fla230V: 0, fla460V: 302, fla575V: 242, fla2300V: 60 },
  { hp: 300, fla115V: 0, fla200V: 0, fla208V: 0, fla230V: 0, fla460V: 361, fla575V: 289, fla2300V: 72 },
  { hp: 350, fla115V: 0, fla200V: 0, fla208V: 0, fla230V: 0, fla460V: 414, fla575V: 336, fla2300V: 83 },
  { hp: 400, fla115V: 0, fla200V: 0, fla208V: 0, fla230V: 0, fla460V: 477, fla575V: 382, fla2300V: 95 },
  { hp: 450, fla115V: 0, fla200V: 0, fla208V: 0, fla230V: 0, fla460V: 515, fla575V: 412, fla2300V: 103 },
  { hp: 500, fla115V: 0, fla200V: 0, fla208V: 0, fla230V: 0, fla460V: 590, fla575V: 472, fla2300V: 118 },
];

/**
 * Get NEC FLA for single-phase motor
 * @param hp - Motor horsepower
 * @param voltage - Motor voltage (115, 200, 208, 230)
 * @returns FLA or undefined if not found
 */
/**
 * Fractional ratings (1/6, 1/3 HP) are carried as 0.167 and 0.333; a user
 * typing 0.1667 or computing 1/3 must still land on the row.
 */
const HP_MATCH_TOLERANCE = 0.001;
export function isSameHP(a: number, b: number): boolean {
  return Math.abs(a - b) < HP_MATCH_TOLERANCE;
}

export function getSinglePhaseFLA(hp: number, voltage: number): number | undefined {
  const entry = TABLE_430_248.find(m => isSameHP(m.hp, hp));
  if (!entry) return undefined;

  switch (voltage) {
    case 115:
    case 120:
      return entry.fla115V;
    case 200:
      return entry.fla200V;
    case 208:
      return entry.fla208V;
    case 230:
    case 240:
      return entry.fla230V;
    default:
      return undefined;
  }
}

/**
 * Get NEC FLA for three-phase motor
 * @param hp - Motor horsepower
 * @param voltage - Motor voltage (115, 200, 208, 230, 460, 575)
 * @returns FLA or undefined if not found
 */
export function getThreePhaseFLA(hp: number, voltage: number): number | undefined {
  const entry = TABLE_430_250.find(m => isSameHP(m.hp, hp));
  if (!entry) return undefined;

  switch (voltage) {
    case 115:
    case 120:
      return entry.fla115V > 0 ? entry.fla115V : undefined;
    case 200:
      return entry.fla200V > 0 ? entry.fla200V : undefined;
    case 208:
      return entry.fla208V > 0 ? entry.fla208V : undefined;
    case 230:
    case 240:
      return entry.fla230V > 0 ? entry.fla230V : undefined;
    case 460:
    case 480:
      return entry.fla460V > 0 ? entry.fla460V : undefined;
    case 575:
    case 600:
      return entry.fla575V > 0 ? entry.fla575V : undefined;
    case 2300:
    case 2400:
      return entry.fla2300V > 0 ? entry.fla2300V : undefined;
    default:
      return undefined;
  }
}

/**
 * Get motor FLA based on phase configuration
 * @param hp - Motor horsepower
 * @param voltage - Motor voltage
 * @param phase - 'single' or 'three'
 * @returns FLA or undefined
 */
export function getMotorFLA(
  hp: number,
  voltage: number,
  phase: 'single' | 'three'
): number | undefined {
  if (phase === 'single') {
    return getSinglePhaseFLA(hp, voltage);
  }
  return getThreePhaseFLA(hp, voltage);
}

// Valid HP values for NEC tables
export const VALID_HP_SINGLE_PHASE = [0.167, 0.25, 0.333, 0.5, 0.75, 1, 1.5, 2, 3, 5, 7.5, 10];
export const VALID_HP_THREE_PHASE = [0.5, 0.75, 1, 1.5, 2, 3, 5, 7.5, 10, 15, 20, 25, 30, 40, 50, 60, 75, 100, 125, 150, 200, 250, 300, 350, 400, 450, 500];
export const VALID_HP_2300V = [60, 75, 100, 125, 150, 200, 250, 300, 350, 400, 450, 500];

export interface FLALookupResult {
  fla: number;
  matchedHP: number;
  wasRoundedUp: boolean;
}

/**
 * Get motor FLA with round-up logic for non-standard HP values.
 * If the exact HP is not in the NEC table, rounds up to the next larger HP
 * that has data at the given voltage.
 * @returns FLALookupResult or undefined if HP exceeds table maximum
 */
export function getMotorFLAWithRoundUp(
  hp: number, voltage: number, phase: 'single' | 'three'
): FLALookupResult | undefined {
  // Try exact match first
  const exactFLA = getMotorFLA(hp, voltage, phase);
  if (exactFLA !== undefined) {
    return { fla: exactFLA, matchedHP: hp, wasRoundedUp: false };
  }

  // Find the next larger HP that has data at this voltage
  const table = phase === 'single' ? TABLE_430_248 : TABLE_430_250;
  for (const entry of table) {
    if (entry.hp <= hp) continue;

    // Check if this entry has data for the requested voltage
    const fla = phase === 'single'
      ? getSinglePhaseFLA(entry.hp, voltage)
      : getThreePhaseFLA(entry.hp, voltage);

    if (fla !== undefined) {
      return { fla, matchedHP: entry.hp, wasRoundedUp: true };
    }
  }

  // No larger HP found with data at this voltage
  return undefined;
}

export const NEC_TABLE_430_248_REF = {
  table: 'Table 430.248',
  article: '430.248',
  description: 'Full-Load Current, Single-Phase Alternating-Current Motors',
};

export const NEC_TABLE_430_250_REF = {
  table: 'Table 430.250',
  article: '430.250',
  description: 'Full-Load Current, Three-Phase Alternating-Current Motors',
};

export { TABLE_430_248, TABLE_430_250 };
